export enum MeetingStatus {
  DRAFTED = 'drafted',
  ANNOUNCED = 'announced',
  FINISHED = 'finished',
  CANCELED = 'canceled',
}

export enum AttendeesInclusion {
  ALL = 'all',
  INCLUDE = 'include',
  EXCLUDE = 'exclude',
  OWNERSHIP = 'ownership',
}
